<template>
  <b-container class="mt-4">
    <b-row>
      <b-col v-if="loading" class="text-center text-primary">
        <b-spinner class="align-middle"></b-spinner>
        <strong>Loading...</strong>
      </b-col>
      <b-col v-else>
        
        <!-- Filters -->
        <b-container class="mb-4 text-center">
          <b-row class="mb-3">
            <b-col>
              <b-button v-b-modal.tweeters-modal variant="secondary">Filter media</b-button>
              <b-modal id="tweeters-modal" title="Filter media" hide-footer size="lg">
                <b-form-checkbox
                  v-for="tweeter in tweeters"
                  v-model="selectedTweeters"
                  :key="tweeter"
                  :value="tweeter"
                  inline
                >
                  {{ tweeter }}
                </b-form-checkbox>
              </b-modal>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col offset-md="2" md="8">
              <b-form-input v-model="searchString" placeholder="Search tweet text.."></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col offset-md="2" md="8">
              <b-form-input v-model="maxAge" type="range" min="1" max="24"></b-form-input>
              <small>Maximum age: {{ maxAge }} hours</small>
            </b-col >
          </b-row>
        </b-container>

        <!-- List of tweets -->
        <b-card no-body>
          <table>
            <tr
              class="tweet-row"
              v-for="(tweet, ii) in filtered"
              v-bind:key="ii"
              :style="{ backgroundColor: rowColor(tweet) }"
              @click="rowClick(tweet)"
            >
              <th class="tweeter">{{ tweet.tweeter }}</th>
              <th class="tweet-age">{{ ageString(tweet.age) }}</th>
              <th class="tweet-text">{{ tweet.text }}</th>
            </tr>
          </table>
        </b-card>

      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from 'axios';
import { endpoints } from '../constants';

export default {
  name: 'storyHunter.vue',
  data() {
    return {
      maxAge: 12,
      searchString: '',
      tweeters: [],
      selectedTweeters: [],
      tweets: [],
    };
  },
  computed: {
    loading() { return this.tweets.length === 0 },
    filtered() {
      return this.tweets.filter(tweet =>
        tweet.age < this.maxAge * 3600 &&
        this.selectedTweeters.includes(tweet.tweeter) &&
        tweet.text.toLowerCase().includes(this.searchString)
      );
    },
  },
  created() {
    this.updateTweeters();
    this.updateTweets();
    this.timer = setInterval(this.updateTweets, 30000);
  },
  methods: {
    async updateTweeters() {
      console.log('updating tweeters');
      const response = await axios.get(endpoints.tweeters);
      this.tweeters = response.data.tweeters;
      this.selectedTweeters = this.tweeters.slice();
    },
    async updateTweets() {
      console.log('updating tweets');
      const response = await axios.get(endpoints.virality);
      this.tweets = response.data.tweets;
    },
    rowClick(record) {
      window.open(record.url);
    },
    rowColor(tweet) {
      const scale = tweet.virality / 0.01
      const scaleReduced = Math.min(scale, 1)
      const gbStrength =  (1 - scaleReduced) * 255;
      return `rgb(255, ${gbStrength}, ${gbStrength})`
    },
    ageString(age) {
      const hours = Math.floor(age / 3600);
      const mins = Math.floor((age - 3600 * hours) / 60);
      if (hours) {
        return `${hours}h ${mins}m`;
      }
      return `${mins}m`;

    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style scoped>
  .tweet-row {
    font-size: 17px;
    text-align: left;
    cursor: pointer;
  }
  .tweet-row:hover {
    background-color: darkgrey!important;
  }
  .tweeter {
    width: 130px;
    font-weight: bold;
  }
  .tweet-age {
    width: 120px;
    text-align: right;
    font-weight: normal;
  }
  .tweet-text {
    font-style: italic;
    font-weight: normal;
  }
  th, td {
    padding: 10px 20px;
  }
</style>
